import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatPoints' })
export class PointsPipe implements PipeTransform {
  transform(value?: number | undefined): string {
    if (!value) {
      return '';
    }
    if (value < 0) {
      return `-${Math.abs(value)}`;
    } else {
      return `+${value}`;
    }
  }
}
